export const GAME_CONFIG = {

    // =========================================
    // GAME SETTINGS
    // =========================================

    rewardedPointsName: {
        translations: {
            en: "points",
            fr: "points"
        }
    },

    limitedMoves: true,
    numberOfMoves: 10,
    numberOfMovesRemaining: 10,

    attemptsCount: 0,
    attempts: 0,

    userTimer: false,
    gameMode: 'timer',

    startTime: 20,
    remainingTime: 20,

    // Swap animation speed in milliseconds
    swapDuration: 500,

    // =========================================
    // POINTS
    // =========================================

    pointsRewardThreshold: [
        {
            requiredPoints: 500,
            reward: 10
        }
    ],

    minimumLengthForPoints: 3,
    minimumPointsGain: 50,
    pointsMutiplier: 15,
    bonusPointsMultiGroups: 50,

    // =========================================
    // VISUALS
    // =========================================

    gamebackgroundColor: "#0E011D",

    // =========================================
    // GRID
    // =========================================

    cellWidth: 48,
    cellHeight: 48,

    cols: 5,
    rows: 6,

    // =========================================
    // DONUT TYPES
    // =========================================

    /*
    donutTypes: [
        { texture: 'pinkDonut', color: 0xffffff, value: 1, special: null },
        { texture: 'darkBlueDonut', color: 0x6666ff, value: 5, special: null },
        { texture: 'purpleDonut', color: 0xbecc43, value: 2, special: null },
        { texture: 'lightBlueDonut', color: 0x098324, value: 3, special: null },
        { texture: 'tealSprinkledDonut', color: 0x098324, value: 4, special: null },
    ],
    */

    donutTypes: [
        { texture: 'biscoff', color: 0xffffff, value: 1, special: null },
        { texture: 'cannoli', color: 0x6666ff, value: 5, special: null },
        { texture: 'chocosprinkles', color: 0xbecc43, value: 2, special: null },
        { texture: 'cookiemonster', color: 0x098324, value: 3, special: null },
        { texture: 'cremebrulee', color: 0x098324, value: 4, special: null },
    ],

    // =========================================
    // WIN TEXT
    // =========================================

    winningCatchphrase: [
        /*
        { boldText: 'Sweet victory', regularText: ' — the donuts are yours!', color: 0xffffff },
        { boldText: 'You nailed it!', regularText: ' Enjoy your well-earned donuts.', color: 0xffffff },
        { boldText: 'Winner winner…', regularText: ' donut dinner!', color: 0xffffff },
        { boldText: 'You beat the clock', regularText: ' — treat yourself!', color: 0xffffff },
        { boldText: 'Glazed and amazed', regularText: ' — you won!', color: 0xffffff },
        { boldText: 'Quick play,', regularText: ' sweet reward!', color: 0xffffff },
        { boldText: 'That’s how you snag the sweets!', regularText: '', color: 0xffffff },
        { boldText: 'Victory tastes like donuts!', regularText: '', color: 0xffffff },
        { boldText: 'You brought the speed', regularText: ' — take the treat!', color: 0xffffff },
        */
       { boldText: '', regularText: 'Tu peux continuer à jouer pour accumuler encore plus de points et tenter de battre ton meilleur score!', color: 0xffffff },
    ],

    // =========================================
    // LOSE TEXT
    // =========================================

    losingCatchphrase: [
        /*
        { boldText: '', regularText: 'Nice try! The donuts are still up for grabs.', color: 0xffffff },
        { boldText: '', regularText: 'Good effort! The glaze wasn’t in your favor this time.', color: 0xffffff },
        { boldText: '', regularText: 'Close one! The donuts are rolling to the next player.', color: 0xffffff },
        { boldText: '', regularText: 'Sweet attempt! Give it another go.', color: 0xffffff },
        { boldText: '', regularText: 'Almost had it! The donuts are playing hard to get.', color: 0xffffff },
        { boldText: '', regularText: 'So close! The donuts needed lightning speed.', color: 0xffffff },
        { boldText: '', regularText: 'Blink and you miss it! Try again for that sweet win.', color: 0xffffff },
        { boldText: '', regularText: 'Just a split second shy — take another shot!', color: 0xffffff },
        { boldText: '', regularText: 'The donuts move fast! Ready for round two?', color: 0xffffff },
        { boldText: '', regularText: 'Speed was the secret ingredient this time — go again!', color: 0xffffff },
        */
       { boldText: '', regularText: 'Les choses sérieuses commencent. est-tu prêt pour le niveau 2?', color: 0xffffff },
    ],


    // testing
    maxCellSize: 60,

    //gridTopPadding: 80,
    gridTopPadding: 235,

    gridBottomSpacing: 40,

    //timerBoxWidth: 240,
    //timerBoxHeight: 60,

    bottomPadding: 20,
};